/* List of projects using the same origin App */

const config = require('./' + process.env.REACT_APP_PROJECT_NAME + '-sidebar-config');
export default config;
